import { object, string } from 'yup';

export const SignupArtistInfoSchema = object().shape({
  bioHTML: string().label('Bio').trim().max(1000),
});

export const SignupArtistInfoRequiredSchema = object().shape({
  bioHTML: string().label('Bio').trim().max(1000)
    .required(),
});
